import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/SourceSansPro-ExtraLight.woff2%22,%22weight%22:%22200%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/SourceSansPro-Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/SourceSansPro-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/SourceSansPro-Semibold.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/SourceSansPro-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./font-files/SourceSansPro-Black.woff2%22,%22weight%22:%22900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false}],%22variableName%22:%22sourceSansPro%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sourceSansPro'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
